var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommandersOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.65V7.01C2 5.9 2.9 4.99 4.02 4.99H22.85C23.96 4.99 24.87 5.89 24.87 7.01V18.22C24.87 19.33 23.97 20.24 22.85 20.24H12.59M9.19 20.24C9.19 16.28 5.97 13.05 2 13.05M5.79 20.24C5.79 18.15 4.09 16.45 2 16.45M2.38 20.24C2.38 20.03 2.21 19.86 2 19.86",
    stroke: "#FF43AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandersOn);
export default __webpack_public_path__ + "static/media/commandersOn.1afcde8ae321ac8ce07d62da1dec5880.svg";
export { ForwardRef as ReactComponent };